import { render, staticRenderFns } from "./LowBalanceAccountrms.vue?vue&type=template&id=a9c31c12"
import script from "./LowBalanceAccountrms.vue?vue&type=script&lang=js"
export * from "./LowBalanceAccountrms.vue?vue&type=script&lang=js"
import style0 from "./LowBalanceAccountrms.vue?vue&type=style&index=0&id=a9c31c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports